import React from 'react';
import PropTypes from 'prop-types';

const HeadlineModalTip = props => {
  return (
    <li key={props.tip.title}>
      <div className="title-container">
        <i className="list ss-navigateright" />
        <div className="title">{props.tip.title}</div>
      </div>
      <div
        dangerouslySetInnerHTML={{ __html: props.tip.description }}
        className="description"
      />
    </li>
  );
};

HeadlineModalTip.propTypes = {
  tip: PropTypes.shape({
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired
  }).isRequired
};

export default HeadlineModalTip;
